import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const StatusIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 18 15"
    >
      <defs>
        <clipPath>
          <rect width="18" height="14.599" transform="translate(0 0)" fill="none" stroke={color} strokeWidth="1" />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g clipPath="url(#clipPath)">
          <path
            d="M5.114,3.822h11.24a.734.734,0,0,1,.734.734v8.808a.734.734,0,0,1-.734.735H2.161A1.661,1.661,0,0,1,.5,12.438V2.161"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            d="M2.161.5a1.661,1.661,0,0,0,0,3.322H6.094V.5Z"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <line
            y2="3.16"
            transform="translate(6.094 0.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  </CircledIcon>
);
